const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20themed%20spotlight%20display%20with%20warm%20orange%20and%20amber%20glowing%20highlights%2C%20featured%20content%20card%20with%20prominent%20title%2C%20editorial%20magazine%20cover%20style%2C%20luxurious%20dark%20gradient%20background%20with%20subtle%20texture&width=800&height=500&seq=carousel-img-01&orientation=landscape',
    title: '51黑料网 · 六月热点全景',
    desc: '本月51黑料最新发布内容全部收录，热度排名、话题讨论、精彩回顾一站呈现。',
    tag: '热门专题',
    tagColor: 'primary' as const,
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20futuristic%20portal%20entrance%20with%20multiple%20glowing%20rings%20in%20warm%20amber%20and%20orange%2C%20navigation%20gateway%20concept%2C%20abstract%20geometric%20design%2C%20cinematic%20atmospheric%20lighting%2C%20premium%20editorial%20style&width=800&height=500&seq=carousel-img-02&orientation=landscape',
    title: '91黑料入口 · 最新地址汇总',
    desc: '91黑料网全部入口地址实时更新，安全直达91黑料吃瓜最新内容，无需反复搜索。',
    tag: '入口导航',
    tagColor: 'accent' as const,
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20themed%20video%20showcase%20wall%20with%20multiple%20thumbnail%20previews%20in%20warm%20orange%20tones%2C%20content%20collection%20display%2C%20play%20button%20overlays%2C%20cinematic%20mood%2C%20editorial%20photography%20quality&width=800&height=500&seq=carousel-img-03&orientation=landscape',
    title: '17黑料吃瓜视频精选合集',
    desc: '17黑料网热门吃瓜视频一网打尽，从实时追踪到经典回顾，精彩不容错过。',
    tag: '视频合集',
    tagColor: 'primary' as const,
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20archive%20collection%20with%20layered%20content%20tiles%20and%20warm%20amber%20glowing%20highlights%2C%20organized%20digital%20library%20display%2C%20catalog%20style%20layout%2C%20premium%20aesthetic%2C%20cinematic%20lighting&width=800&height=500&seq=carousel-img-04&orientation=landscape',
    title: '718黑料合集 · 完整归档',
    desc: '718黑料全系列内容按时间线归档整理，支持快速检索与回顾，收录最完整的黑料系列。',
    tag: '完整归档',
    tagColor: 'secondary' as const,
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20themed%20ranking%20display%20with%20glowing%20orange%20and%20amber%20gradient%20chart%20bars%2C%20trending%20data%20visualization%2C%20leaderboard%20concept%2C%20modern%20dashboard%20aesthetic%2C%20warm%20accent%20lighting&width=800&height=500&seq=carousel-img-05&orientation=landscape',
    title: '本周黑料人气飙升榜',
    desc: '基于全平台数据统计的实时热度榜单，51黑料、91黑料、17黑料话题热度一目了然。',
    tag: '数据榜单',
    tagColor: 'accent' as const,
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20atmospheric%20discussion%20forum%20visual%20with%20floating%20topic%20cards%20and%20warm%20orange%20accent%20highlights%2C%20community%20engagement%20concept%2C%20trending%20labels%2C%20modern%20social%20platform%20aesthetic&width=800&height=500&seq=carousel-img-06&orientation=landscape',
    title: '黑料51社区热议话题',
    desc: '黑料51社区本周最火爆的讨论话题汇总，看看大家都在关注哪些黑料热点。',
    tag: '社区热议',
    tagColor: 'primary' as const,
  },
];

const tagCls: Record<string, string> = {
  primary: 'bg-primary-500/90 text-background-50',
  accent: 'bg-accent-500/90 text-background-50',
  secondary: 'bg-secondary-500/90 text-background-50',
};

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">专题合集</h2>
          <p className="mt-2 text-sm text-foreground-600">黑料系列品牌专题内容一站式速览</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item, idx) => (
            <article
              key={idx}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200/30 transition-all cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-900/40 to-transparent"></div>
                <span className={`absolute top-3 left-3 px-2.5 py-1 rounded-md text-xs font-bold whitespace-nowrap ${tagCls[item.tagColor]}`}>
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-bold font-heading text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}